/**
 * EntityStats API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import { queryEntityStats } from "../generated/entity-stats/entity-stats";

import { wrapMethod } from "./utils";

export const entityStats = {
  /** @see queryEntityStats */
  queryEntityStats: wrapMethod(queryEntityStats),
} as const;

export type EntityStatsApi = typeof entityStats;
